import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { LangContext } from "../LangContext.jsx";

class CompleteInformationCol extends Component {
    constructor(props) {
        super();
        this.state = {
            rfcReadOnly:false,
            readOnlyFiscalName:false,
            rfc:'',
            name:'',
            adress:'',
            fiscalName:'',
            zipCode:'',
            countries: [],
            states: [],
            cities: [],
            municipalityId:'',
            country:'',
            selectedCountry: '',
			selectedState: '',
            internalIdReadOnly:false,
            personTypeReadOnly:false,
            internalId:'',
            personType:'Natural',
            fv: [],
        };
        this.changeCountry = this.changeCountry.bind(this);
        this.changeName = this.changeName.bind(this);
		this.changeState = this.changeState.bind(this);
        this.changeRFC = this.changeRFC.bind(this);
        this.changeFiscalName = this.changeFiscalName.bind(this);
		this.changeAdress = this.changeAdress.bind(this);
        this.changeZipcode = this.changeZipcode.bind(this);
        this.fvMx = null
        this.fvCol = null
    }
    validate = ()=> {
        this.fv.validate().then((status) => {
            if (status == 'Valid') {
                this.createPerson()
            }
        });
    }
    componentDidMount() {
        this.setState({name:this.props.name});
        this.props.rfc != ''  ? this.setState({rfcReadOnly:true}) : null;
        this.props.fiscalName != ''  ? this.setState({fiscalName:this.props.fiscalName}) : null;
        this.props.fiscalName != ''  ? this.setState({readOnlyFiscalName:true}) : null; 
        this.props.internalId != ''  ? this.setState({internalIdReadOnly:true}) : null;
        this.props.personType != ''  ? this.setState({personTypeReadOnly:true}) : null;
        this.setState({rfc:this.props.rfc});
        if(this.props.personType == 2){
            this.setState({personType:'Jurídica'});
        }
        if(this.props.personType == 1){
            this.setState({personType:'Natural'});
        }
        
        this.setState({internalId:this.props.internalid});
        this.getStates(2)
        let self = this
        this.fv = FormValidation.formValidation(KTUtil.getById('frm'), {
            fields: {
                name: {
                    validators: {
                        notEmpty: {
                            message: 'Nombre requerido'
                        },
                        stringLength: {
                            min: 4,
                            max: 200,
                            message: 'El nombre debe tener una longitud mínima de 4'
                        },
                    }
                },
                rfc: {
                    validators: {
                        callback: { 
                            callback: async function(input) { 

                                if (self.state.rfcReadOnly) {
                                    return { valid: true };
                                }
                                
                                let r;
                                let pt;
                                if(self.state.personType == 'Jurídica'){
                                    pt =2
                                }else{
                                    pt = 1
                                }
                                await axios.post('/api/validate-rfc',{
                                    country:2,
                                    allowMoralProviders:true,
                                    rfc:input.value.toUpperCase(),
                                    personType:pt,
                                    isInvitation:false
                                }).then(res=>{
                                    r =   {
                                        valid: res.data.isValid,
                                        message: res.data.message,
                                    }; 
                                })
                                return r
                            }
                        }
                    }
                },
                fiscal_name: {
                    validators: {
                        notEmpty: {
                            message: 'Nombre fiscal requerido'
                        },
                        stringLength: {
                            min: 4,
                            max: 200,
                            message: 'El nombre fiscal debe tener una longitud mínima de 4'
                        },
                    }
                },
                address1: {
                    validators: {
                        notEmpty: {
                            message: 'Dirección requerida'
                        },
                        stringLength: {
                            min: 4,
                            max: 200,
                            message: 'La direcciión debe tener una longitud mínima de 4'
                        },
                    }
                },
                zipcode: {
                    validators: {
                        notEmpty: {
                            message: 'C.P. requerido'
                        },
                        digits: {
                            message: 'El C.P. debe contener solo dígitos'
                        },
                        stringLength: {
                            min: 5,
                            max: 6,
                            message: 'El C.P. debe tener una longitud mínima de 5'
                        },
                    }
                },

            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                submitButton: new FormValidation.plugins.SubmitButton(),
                defaultSubmit: new FormValidation.plugins.DefaultSubmit(),
                bootstrap: new FormValidation.plugins.Bootstrap({
                    eleInvalidClass: '',
                    eleValidClass: '',
                })
            },
        })
    }
    changeMunicipality = (event)=>{
        this.setState({ municipalityId: event.target.value });
    }
    async createPerson(){
        let formData = {
            name: this.state.name,
            rfc: this.state.rfc,
            fiscal_name: this.state.fiscalName,
            address1: this.state.adress,
            zipcode: this.state.zipCode,
            municipality_id: this.state.municipalityId, 
            country:2,
            person_type:this.state.personType,
            internal_id:this.state.internalId,
            people_id:this.props.peopleId,
        };
        
        if(this.props.route != undefined){
            const res = await axios.post(this.props.route,formData).then(res=>{
                window.location.href = '/company/select';
            })
        }else{ 
            const res = await axios.post('/persons/register',formData).then(res=>{
                window.location.href = '/'+res.data;
            })
        }
        const data = res.data
        window.blockUI();
        KTUtil.btnWait(KTUtil.getById('btnPublish'), 'spinner spinner-right spinner-white pr-15', "Procesando...");
    }

    changeInternalId = (event)=>{
        this.setState({ internalId: event.target.value });
    }
    
    handlePersonTypeChange = (event) => {
        this.setState({
            personType: event.target.value,
        });
        if(this.state.rfc != ''){
            this.fv.revalidateField('rfc');
        } 
    };
    
    async getCountries() {
        const res = await axios.get('/api/countries')
        const data = res.data
        const options = data.map(c => ({
            "value" : c.id,
            "label" : c.name
        }))
        this.setState({countries: options})
    }

    async getStates(country){
        this.setState({selectedCountry: country})
        const res = await axios.get('/api/states?country=' + country)
        const data = res.data
        const options = data.map(s => ({
            "value" : s.id,
            "label" : s.name
        }))
        this.setState({states: options})
    }

    async getCities(state){
        this.setState({selectedState: state})
        const res = await axios.get('/api/municipalities?state=' + state)
        const data = res.data
        const options = data.map(c => ({
            "value" : c.id,
            "label" : c.name
        }))
        this.setState({cities: options})
    }

    changeCountry(event) {
        this.setState({country: event.target.value})
        this.getStates(event.target.value)
	}

    changeFiscalName(event){
        this.setState({fiscalName:event.target.value});
    }

    changeAdress(event){
        this.setState({adress:event.target.value});
    }

    changeMunicipio = (event)=>{
        this.setState({municipality:event.target.value});
    }

    changeDepartamento = (event)=>{
        this.setState({departamento:event.target.value});
    }

    changeZipcode(event){
        this.setState({zipCode:event.target.value});
    }

    changeName(event){
        this.setState({name:event.target.value});
    }

    changeRFC(event){
        if(!this.state.rfcReadOnly){
            const value = event.target.value.toUpperCase();
            this.setState({ rfc: value });
        }
    }

	changeState(event) {
		this.getCities(event.target.value)
	}

    render() {
        const { countries } = this.state
        return (
            <>
            <div   id="frm"  class="col-12">
            <div className="row justify-content-center text-left">
            <div className="col-sm-6 form-group">
                <label className="text-left font-weight-bold text-dark-light">Departamento</label>
                <select id={this.props.state} name={this.props.state}
                placeholder={this.props.state}
                value={this.state.selectedState}
                onChange={this.changeState} className="form-control form-control-solid">
                    <option>--Seleccionar--</option>
                    {this.state.states.map((o, i) => {
                        return <option key={i} value={o.value}>{o.label}</option>;
                    })}
                </select>
            </div>
            <div className="col-sm-6 form-group">
                <label className="text-left font-weight-bold text-dark-light">Municipio</label>
                    <select id={this.props.city}
                    name='municipality_id'
                    placeholder={this.props.city}
                    onChange={this.changeMunicipality}
                    className="form-control form-control-solid" required>
                        <option value="">--Seleccionar--</option>
                        {this.state.cities.map((o, i) => {
                            return <option key={i} value={o.value}>{o.label}</option>;
                        })}
                    </select>
                </div>
            </div>
            <div class="row text-left">
                    <div class="col-sm-6 form-group">
                        <label for="name" class="text-left font-weight-bold">Nombre</label>
                        <input id="name" type="text" class="form-control form-control-solid" name="name" value={this.state.name} required   autofocus onChange={this.changeName}/>
                    </div>
                    <div class="col-sm-6 form-group">
                        <label for="person_type" class="text-left font-weight-bold">Tipo de Personas</label>
                        <select id="person_type" disabled={this.state.personTypeReadOnly} name="person_type"    onChange={this.handlePersonTypeChange} class="form-control form-control-solid"
                        value={this.state.personType}
                        >
                            <option value="Natural">Natural</option>
                            <option value="Jurídica">Jurídica</option>
                        </select>
                    </div>
                </div>
                <div class="row text-left">
                    <div class="col-sm-6 form-group">
                        <label for="rfc" class="text-left font-weight-bold">
                            {this.state.personType == 'Natural' && 'Cédula de Ciudadanía' }
                            {this.state.personType === 'Jurídica' && (
                            <span>NIT <span  className="text-muted">(xxxxxxxxx-x)</span></span>
                            )}
                        </label>
                        <input id="rfc" class="form-control form-control-solid" name="rfc" value={this.state.rfc} disabled={this.state.rfcReadOnly} readOnly={this.state.rfcReadOnly} onChange={this.changeRFC}
                        maxlength="20"
                        onkeyup="javascript:this.value=this.value.toUpperCase();"/>
                    </div>
                    <div class="col-sm-6 form-group">
                        <label for="fiscal_name" class="text-left font-weight-bold">
                            {this.state.personType == 'Natural' && 'Nombre Completo' }
                            {this.state.personType == 'Jurídica' && 'Razón Social ' } </label>
                        <input id="fiscal_name" class="form-control form-control-solid "   readOnly={this.state.readOnlyFiscalName} value={this.state.fiscalName}  onChange={this.changeFiscalName} name="fiscal_name" />
                    </div>
                </div>
                <div class="row text-left">
                    <div class="col-sm-6 form-group">
                        <label for="address1" class="text-left font-weight-bold"> Dirección </label>
                        <input id="address1" class="form-control form-control-solid "  value={this.state.adress}  onChange={this.changeAdress} name="address1"   required />
                    </div>
                    <div class="col-sm-6 form-group">
                        <label for="zipcode" class="text-left font-weight-bold"> C.P. </label>
                        <input id="zipcode" class="form-control form-control-solid  " value={this.state.zipCode}  onChange={this.changeZipcode} name="zipcode" />
                    </div> 
                </div> 
            </div>
            <button type="button" onClick={()=> {this.validate()}  } className="btn btn-primary font-weight-bolder mr-2">Crear Cuenta</button>
            </>
        );
    }
}

export default CompleteInformationCol;

if (document.getElementById('CompleteInformationCol')) {
    ReactDOM.render(<CompleteInformationCol />, document.getElementById('CompleteInformationCol'));
}
